<template>
  <div>
    <SectionWrapper class="whiteframe">
      <h1 class="loginHeadline">Sign in to your Account</h1>
      <Login :enable-third-party="true">
        <template slot="formBottom">
          <router-link
            class="forgotPassword"
            :to="{ name: pages.AUTH_PASSWORD_REMINDER }"
            >Forgot Your Password?</router-link
          >
        </template>
      </Login>
    </SectionWrapper>
    <DividerSeparator>
      <DecoratedButton
        type="link"
        name="register-button"
        :route="{ name: pages.AUTH_REGISTER }"
        class="wide short dark-blue"
        fontSize=".8em"
      >
        CREATE AN ACCOUNT
      </DecoratedButton>
    </DividerSeparator>
  </div>
</template>

<script>
import ThirdPartyLogin from "@/components/partials/auth/ThirdPartyLogin";

import FormWithCaptcha from "@/components/partials/FormWithCaptcha";

import Login from "@/components/partials/auth/Login";

export default {
  name: "auth-login",
  components: { FormWithCaptcha, Login, ThirdPartyLogin }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loginHeadline {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  margin-top: 0;
}
</style>
